<template>
  <div
    class="min-h-[200px] rounded-[10px] h-full border border-[#B7B2B5] bg-white p-[20px]"
  >
    <div class="w-full flex flex-col items-center gap-[20px]">
      <div class="title text-[#1F1D1F] self-stretch">ข่าวประชาสัมพันธ์</div>
      <div
        class="w-full flex flex-col items-center gap-[20px] px-[28.5px] sm:px-[0px]"
      >
        <div
          v-if="cards.length != 0"
          class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-[24px] sm:gap-[12px]"
        >
          <PublicRelationsCard
            v-for="(pub, index) in cards"
            :key="index"
            :item="pub"
            :editAble="false"
            @read-more="goToNews"
          />
        </div>
        <NoInfoYetComponent
          class="col-span-1 sm:col-span-2 md:col-span-3 xl:col-span-4"
          v-if="cards.length == 0"
          :table="false"
          :icon="'PublicRelationIcon'"
        />
      </div>
      <ButtonComponent
        label="อ่านทั้งหมด"
        :bClass="'btn_shadow--cancel !max-w-[98px] !px-[12px]'"
        :disabled="cards.length === 0"
        @clicked="$router.push('/public-relations')"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useNewsStore } from "@/pinia/news";

const router = useRouter();

const newsStore = useNewsStore();

const cards = ref([]);

onMounted(async () => {
  await getNews();
});

async function getNews() {
  const s = await newsStore.getNews({ limit: 4 });
  cards.value = s.data.data;
}

function goToNews(data) {
  localStorage.setItem("newID", JSON.stringify(data));
  localStorage.setItem("inShelter", false);
  router.push(`/dashboard/${data.title}`);
}
</script>